import { render, staticRenderFns } from "./workshop-view.vue?vue&type=template&id=d5fc7ab4&scoped=true&"
import script from "./workshop-view.vue?vue&type=script&lang=ts&"
export * from "./workshop-view.vue?vue&type=script&lang=ts&"
import style0 from "./workshop-view.vue?vue&type=style&index=0&id=d5fc7ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fc7ab4",
  null
  
)

export default component.exports